/* eslint-disable jsx-a11y/anchor-is-valid */
import { redirect, useLocation, useNavigate } from "react-router";
import ToggleBtn from "../SidebarComponent/ToggleBtn/ToggleBtn";
import "./Nav.css";
import { FontIcon } from "@fluentui/react";
import { group } from "console";
// import { logoutUser } from "../../services/auth/AuthAPI";

function AuthNav(props: any) {
  const user = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("userData")))).idToken.payload;
  const isAdmin = user["cognito:groups"].includes("engage-transcription-admins");
  const location = useLocation().pathname;
  const navigate = useNavigate();
  return (
    <>
      <nav className="navbar navbar-expand-lg  position-sticky top-0 d-flex flex-column">
        <div className="container-fluid d-flex align-items-center px-2 py-0">
          <ToggleBtn />
          <a
            className="navbar-brand "
            href="/auth">
            <img
              src={require("../../../assets/img/logo.png")}
              alt=""
            />
          </a>

          <div
            className="collapse navbar-collapse justify-content-between  "
            id="navbarNavAltMarkup">
            <div className="navbar-nav gap-3 "></div>

            <div className="dropdown">
              <button
                className="user-container  "
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <div className="d-flex align-items-center gap-1">
                  <FontIcon
                    iconName="Contact"
                    style={{ fontSize: 16 }}
                  />
                  <span>{user.email}</span>
                  <span className="material-symbols-outlined">arrow_drop_down</span>
                </div>
              </button>

              <div
                className="dropdown-menu drop-menu-container "
                aria-labelledby="dropdownMenuButton">
                <a
                  className="dropdown-item dropdown-item-customize"
                  onClick={() => console.log("logout")}
                  href="/">
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="nav-items-edit d-flex gap-1 w-100 px-3">
          <div
            className="nav-item"
            onClick={() => navigate("inprogress")}>
            <button className={`nav-link ${location.includes("inprogress") || location.includes("archived") || location.includes("completed") || location.includes("pack") ? "active" : ""}`}>
              <div className="d-flex align-items-center gap-">
                <div style={{ fontSize: "16px", marginTop: "-1px" }}>JOBS</div>
              </div>
            </button>
          </div>
          {/* <div
            className="nav-item"
            //I want to open the link in a new tab
            onClick={() => window.open("https://dev.translate.wl-engage.com/", "_blank")}>
            <button className={`nav-link ${location === "/" ? "active" : ""}`}>
              <div className="d-flex align-items-center gap-">
                <div style={{ fontSize: "16px", marginTop: "-1px" }}>ENGAGE AI</div>
              </div>
            </button>
          </div> */}
          {isAdmin && (
            <div
              className="nav-item"
              onClick={() => navigate("organizations")}>
              <button className={`nav-link ${location.includes("organizations") || location.includes("users") ? "active" : ""}`}>
                <div className="d-flex align-items-center gap-">
                  <div style={{ fontSize: "16px", marginTop: "-1px" }}>SETTINGS</div>
                </div>
              </button>
            </div>
          )}
        </div>
      </nav>
      <hr style={{ marginBottom: "20px", border: "1px solid #ccc" }} /> {/* Horizontal line */}
    </>
  );
}

export default AuthNav;
